<template>
	<div style="display: flex;align-content: center;width: 98%;justify-content: space-between;margin: auto;">
		
		<div style="font-size: 18px;text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;"><img src="../assets/logo.png"
						style="height: 50px;width: 50px;margin-right: 10px;">NSP管理后台</div>
		<div style="padding-top: 10px;">
			<span style="margin-right: 25px;">欢迎您：{{username}}</span>
			<el-dropdown trigger="click">
				<el-button style=" font-size: 10px;" type="text" size="medium">
					更多操作
					<el-icon class="el-icon-caret-bottom"></el-icon>
				</el-button>
				<el-dropdown-menu slot="dropdown">

					<el-dropdown-item @click.native="quit">退出登录</el-dropdown-item>
					<template>
						<el-dropdown-item @click.native="changePassword">重置密码</el-dropdown-item>
					</template>
					<!-- <el-dropdown-item v-if="userInfo.storeId != 0 && userInfo.storeId != 3" @click.native="tixian">申请提现</el-dropdown-item> -->
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<!-- 重置密码 -->
		<el-dialog title="重置密码" :visible.sync="editDialogVisible" width="35%" :close-on-click-modal="false"
		:append-to-body="true">
			<div >
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item label="登录密码:" :label-width="formLabelWidth">
						<el-col :span="18">
							<el-input v-model="form.password" placeholder="请输入登录密码（6-16位字母+数字）" />
						</el-col>
					</el-form-item>
					<el-form-item label="确认登录密码:" :label-width="formLabelWidth">
						<el-col :span="18">
							<el-input v-model="form.surePass" placeholder="请输入确认登录密码" />
						</el-col>
					</el-form-item>

					<el-form-item>
						<el-button :loading="loading" type="primary" @click="resetPass()">提交</el-button>
						<el-button @click="cannelPass">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	
		<!-- 申请提现 -->
		<el-dialog style="float:rigin" title="申请提现" :closeOnClickModal="false" :visible.sync="applyDatil"
		:close-on-click-modal="false"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item v-if="userInfo.storeCardType == 2"  label="收款人姓名:" class="redItem" style="width: 60%;">
							{{userInfo.storeCardName}}
						</el-form-item>
						<el-form-item v-if="userInfo.storeCardType == 1"  label="收款账户:" class="redItem" style="width: 60%;">
							{{userInfo.storeCardName}}
						</el-form-item>
						<el-form-item v-if="userInfo.storeCardBankNo" label="收款账号:" class="redItem" style="width: 40%;">
							{{userInfo.storeCardBankNo}}
						</el-form-item>
						<el-form-item v-if="!userInfo.storeCardBankNo" label="" class="redItem" style="width: 40%;">
							<el-button  type="primary" @click="addCard">添加收款账号</el-button>
						</el-form-item>
						
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;" v-if="userInfo.storeCardType" >
						<el-form-item label="开户行:" class="redItem" style="width: 60%;">
							{{userInfo.storeCardBank}}
						</el-form-item>
						
						<el-form-item  label="开户支行:" class="redItem" style="width: 40%;">
							{{userInfo.storeCardSubbranch}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="提现金额:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;" v-model="amount" placeholder="请输入提现金额">
							</el-input>
						</el-form-item>
						
						<el-form-item  label="提现额度:" class="redItem" style="width: 40%;">
							{{limtInfo.Store_Withdrawal_Min}} ~~~ {{limtInfo.Store_Withdrawal_Max}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item  label="单日提现额度:" class="redItem" style="width: 40%;">
							{{userInfo.limitDayAmount}}
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="联系电话:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;" v-model="userInfo.phone" disabled placeholder="请输入联系电话">
							</el-input>
							<el-button v-if="flag" type="primary" @click="code" style="border-radius: 30px;margin-left: 10px;">获取验证码</el-button>
							<el-button v-else type="primary" disabled  style="border-radius: 30px;margin-left: 10px;">{{count}}S</el-button>
						</el-form-item>
						
						<el-form-item  label="验证码:" class="redItem" style="width: 40%;">
							<el-input style="width: 200px;" v-model="userInfo.yzm" placeholder="请输入验证码">
							</el-input>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="安全密码:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;"  :show-password='true' v-model="userInfo.password" placeholder="请输入安全密码">
							</el-input>
							
						</el-form-item>
					</div>
				</el-form>
				
			</div>
			<div style="text-align: center;">
				<el-button @click="applyDatil = false">取 消</el-button>
				<el-button type="primary" @click="sure">确 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 添加收款账号弹窗 -->
		<el-dialog style="float:rigin" :closeOnClickModal="false"  title="添加收款账号" :visible.sync="addCardioag"
		:close-on-click-modal="false">
			<div style="margin-bottom: 20px;">
				 <el-radio border v-model="radio" label="1">对公账户</el-radio>
				<el-radio border v-model="radio" label="2">对私账户</el-radio>
			</div>
		  <el-form :model="cardAdd" size="medium" v-if="radio == '1'">
		    <el-form-item label="公司名称:" >
		      <el-input style="width: 200px;" v-model="cardAdd.storeCardName" autocomplete="off" placeholder="请输入公司名称"></el-input>
		    </el-form-item>
		    <el-form-item label="账  号:" >
				<el-input @input="changeCardBank" style="width: 200px;" v-model="cardAdd.storeCardBankNo" autocomplete="off" placeholder="请输入本人银行卡号"></el-input>
		    </el-form-item>
			<el-form-item label="卡 类 型:" >
			  <span style="margin-right: 20px;">{{cardType.bankName}}</span><span>{{cardType.cardTypeName}}</span>
			</el-form-item>
			<el-form-item label="开户支行:" >
			  <el-input style="width: 200px;" v-model="cardAdd.storeCardSubbranch" autocomplete="off" placeholder="请输入开户支行"></el-input>
			</el-form-item>
			<el-form-item label="联 行 号:" >
			  <el-input style="width: 200px;" v-model="cardAdd.storeCardChannelNo" autocomplete="off" placeholder="请输入联行号"></el-input>
			</el-form-item>
			<el-form-item label="手 机 号:" >
			  <el-input style="width: 200px;" v-model="userInfo.phone" disabled autocomplete="off" ></el-input>
			</el-form-item>
			<el-form-item label="验证码:" >
				<el-input   style="width: 200px;" v-model="cardAdd.captcha" placeholder="请输入验证码">
				</el-input>
				 <el-button v-if="flag" type="primary" @click="code2" style="border-radius: 30px;margin-left: 10px;">获取验证码</el-button>
				 <el-button v-else type="primary" disabled  style="border-radius: 30px;margin-left: 10px;">{{count}}S</el-button>
			</el-form-item>
			<el-form-item label="安全密码:" >
			  <el-input style="width: 200px;" v-model="cardAdd.walletPassword" :show-password='true'  placeholder="请输入安全密码" ></el-input>
			</el-form-item>
		  </el-form>
		  
		  <el-form :model="cardAdd" size="medium" v-if="radio == '2'">
		    <el-form-item label="姓名:" >
		      <el-input style="width: 200px;" v-model="cardAdd.storeCardName" autocomplete="off" placeholder="请输入本人姓名"></el-input>
		    </el-form-item>
		    <el-form-item label="卡 号:" >
		  				<el-input @input="changeCardBank" style="width: 200px;" v-model="cardAdd.storeCardBankNo" autocomplete="off" placeholder="请输入本人银行卡号"></el-input>
		    </el-form-item>
		  			<el-form-item label="卡 类 型:" >
		  			  <span style="margin-right: 20px;">{{cardType.bankName}}</span><span>{{cardType.cardTypeName}}</span>
		  			</el-form-item>
		  			<el-form-item label="开户支行:" >
		  			  <el-input style="width: 200px;" v-model="cardAdd.storeCardSubbranch" autocomplete="off" placeholder="请输入开户支行"></el-input>
		  			</el-form-item>
		  			
		  			<el-form-item label="手 机 号:" >
		  			  <el-input style="width: 200px;" v-model="userInfo.phone" disabled  ></el-input>
		  			</el-form-item>
		  			<el-form-item label="验证码:" >
		  				<el-input   style="width: 200px;" v-model="cardAdd.captcha" placeholder="请输入验证码">
		  				</el-input>
		  				 <el-button v-if="flag" type="primary" @click="code2" style="border-radius: 30px;margin-left: 10px;">获取验证码</el-button>
		  				 <el-button v-else type="primary" disabled  style="border-radius: 30px;margin-left: 10px;">{{count}}S</el-button>
		  			</el-form-item>
		  			<el-form-item label="安全密码:" >
		  			  <el-input style="width: 200px;" v-model="cardAdd.walletPassword" :show-password='true'  placeholder="请输入安全密码" ></el-input>
		  			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer" style="text-align: center;">
		    <el-button @click="addCardioag = false">取 消</el-button>
		    <el-button type="primary" @click="addSure">确 定</el-button>
		  </div>
		</el-dialog>
	</div>



</template>

<script>
	export default {
		name: "app",
		props: ['heads'],
		data() {
			return {
				username: "",
				form: {
					password: "",
					surePass: ""
				},
				userInfo:{},
				loading: false,
				mainFormRules: {
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
					surePass: {
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					},
				},
				editDialogVisible: false,
				formLabelWidth: "200px",
				applyDatil:false,
				limtInfo:{},
				storeInfo:{},
				count:60,
				flag:true,
				amount:'',
				addCardioag:false,
				cardAdd:{
					
				},
				cardType:{},
				radio:'1'
			}
		},
		methods: {
			quit() {
				this.$api.lgOut().then(res=>{
					sessionStorage.removeItem("token");
					this.$router.push("/")
				})
				
			},
			tixian(){
			
				this.applyDatil = true
				this.$api.byKey({key:'Store_Withdrawal_Parameter'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.limtInfo =JSON.parse(res.data.settingValue) 
						// console.log(this.limtInfo);
					}
				})
			},
			addCard(){
				this.addCardioag = true
			},
			addSure(){
				if (!/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(this.cardAdd.storeCardName) && this.radio == '1') {
					this.$message({
						message: "请输入公司名称",
						type: 'warning'
					});
					return;
				}
				if (!this.cardAdd.storeCardName && this.radio == '2') {
					this.$message({
						message: "请输入姓名",
						type: 'warning'
					});
					return;
				}
				if (!this.cardAdd.storeCardBankNo) {
					this.$message({
						message: "请输入正确的银行卡号",
						type: 'warning'
					});
					return;
				}
				if (!/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(this.cardAdd.storeCardSubbranch)) {
					this.$message({
						message: "请输入开户支行名称",
						type: 'warning'
					});
					return;
				}
				if(this.radio == '1' && !this.cardAdd.storeCardChannelNo){
					this.$message({
						message: "请输入联行号",
						type: 'warning'
					});
					return;
				}
				if(!this.cardAdd.walletPassword){
					this.$message({
						message: "请输入安全密码",
						type: 'warning'
					});
					return;
				}
				let data = {
					storeCardType:this.radio,
					storeCardBank:this.cardType.bankName,
					...this.cardAdd
				}
				this.$api.addCardNo(this.$encrypt(data)).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.addCardioag = false
						this.getuser()
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			changeCardBank(e){
				this.cardType = this.$bankCardAttribution(e)
			},
			code(){
				this.timeDown()
				this.$api.captCode({phone:this.userInfo.phone,type:"register"}).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
					}
				})
			},
			code2(){
				// console.log(this.userInfo.phone);
				this.timeDown()
				this.$api.captCode({phone:this.userInfo.phone,type:"register"}).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
					}
				})
			},
			// 验证码倒计时
			timeDown(){
				this.count--;
				this.flag = false;
				var timer=setInterval(()=>{
					if(this.count>0){
						this.count--;
						this.flag=false
					}else{
						clearInterval(timer)
						timer = null ;
						this.count = 60;
						this.flag = true
					}
				},1000)
			},
			sure(){
				
			},
			changePassword() {
				this.form = {}
				this.editDialogVisible = true
			},
			//重置密码
			resetPass() {
				if (this.form.password !== this.form.surePass) {
					this.$message.error("两次密码不一致");
					return false;
				}
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
				var re = new RegExp(reg)
				if (!re.test(this.form.password)) {
					this.$message.error("请输入有效的登录密码");
					return false;
				}

				let data = {
					password: this.form.password
				}
				this.$api.sysResetPass(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.editDialogVisible = false;
				})
			},
			cannelPass() {
				this.editDialogVisible = false
			},
			getuser(){
				let user = window.sessionStorage.getItem('token');
				if (user) {
					this.$api.getUserInfo(this.$encrypt({})).then((res) => {
						// console.log('登录数据1---', res.data)
						res.data=JSON.parse(this.$decrypt(res.data)).data
						// console.log('登录数据2---', res.data)
						if (res.state == 'success') {
							this.userInfo = res.data
						
							// this.storeInfo = res.data.store
							this.username = res.data.username
							sessionStorage.setItem('type',res.data.type)
							sessionStorage.setItem('storeId',res.data.storeId)
						}
					})
				}
			}
		},
		created() {
			// console.log(this.$bankCardAttribution('6212855200000315025'));
			this.getuser()
		}
	}
</script>
<style scoped lang="less">
	.sasdfa {
		color: cyan
	}
	/deep/.el-input__inner{
		color: black !important;
	}
	/deep/.el-textarea__inner{
		color: black !important;
	}
</style>
